module.exports = __webpack_public_path__ + "assets/ig-header.b77a7802.svg";